import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

import { installTwicpics } from '@twicpics/components/react';
import '@twicpics/components/style.css';

import './i18n';
import { DevTools, FormatSimple, Tolgee, TolgeeProvider } from '@tolgee/react';

// Load static translations
import en from './i18n/en.json';
import fr from './i18n/fr.json';

installTwicpics({
  domain: `${process.env.REACT_APP_TWIC_DOMAIN || 'domain.twic.pics'}` as string
});

// 🔐 Constants
const DEFAULT_LANG = 'en';
const LOCAL_STORAGE_KEY = 'shekr_lang';

// 🔍 Utility to get user's country & map to language
async function detectUserLanguage(): Promise<'en' | 'fr'> {
  try {
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    const country = data.country;
    if (country === 'FR') return 'fr';
    return 'en';
  } catch (e) {
    return DEFAULT_LANG;
  }
}

(async () => {
  // 1. Get from localStorage or detect
  let lang = localStorage.getItem(LOCAL_STORAGE_KEY) as 'en' | 'fr' | null;

  if (!lang) {
    lang = await detectUserLanguage();
    localStorage.setItem(LOCAL_STORAGE_KEY, lang);
  }

  // 2. Init Tolgee
  const tolgee = Tolgee().use(DevTools()).use(FormatSimple()).init({
    language: lang,
    fallbackLanguage: DEFAULT_LANG,
    staticData: {
      en,
      fr
    }
  });

  await tolgee.run();

  // 3. Render app
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <React.StrictMode>
      <BrowserRouter basename="/">
        <TolgeeProvider tolgee={tolgee}>
          <App />
        </TolgeeProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
})();

reportWebVitals();
